import { render, staticRenderFns } from "./ShortenerIntegration.vue?vue&type=template&id=711bf9a0"
import script from "./ShortenerIntegration.vue?vue&type=script&lang=js"
export * from "./ShortenerIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports